import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RoleRedirectProps {
  children: React.ReactNode;
  /** Papel que NÃO pode ver esta rota. */
  deny: 'empresa' | 'profissional';
  /** Para onde mandar quem tem o papel negado. */
  to: string;
}

/**
 * Deixa passar visitante anônimo e qualquer papel, MENOS `deny`.
 *
 * Diferente do RoleProtectedRoute (que exige login e trava numa única role), este
 * guarda catálogos públicos que um dos lados não deveria navegar — ex.: /times e
 * /substituicoes são o mural de quem procura trabalho; empresa logada ali veria
 * times/substituições de outras empresas e profissionais, então é redirecionada
 * pro espaço dela.
 */
export const RoleRedirect = ({ children, deny, to }: RoleRedirectProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (user?.tipo === deny) {
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
};
